import { Component, ViewChild, inject } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { DIALOG_RETURN_TYPES, DialogService } from '@next/core-lib/dialog';
import { LocaleService } from '@next/core-lib/i18n';
import { SelectedCustomer, UserSelectors } from '@next/core-lib/user';
import { Actions } from '@ngrx/effects';
import { Store, select } from '@ngrx/store';
import { Observable, take } from 'rxjs';
import {
  RequestsColumnTypes,
  RequestsOverviewModel,
} from 'src/app/dashboard/components/overview/models/overview.model';

import { ActiveRequestsOverviewDataSource } from 'src/app/my-advertisements/datasources/active-requests-datasource/active-requests.datasource';

import * as MyAdvertisementsActions from '../../../store/actions/my-advertisements.actions';

@Component({
  selector: 'app-active-requests-overview-table',
  templateUrl: './active-requests-overview-table.component.html',
  styleUrls: ['./active-requests-overview-table.component.scss'],
  standalone: false,
})
export class ActiveRequestsOverviewTableComponent {
  private readonly store = inject(Store);
  private readonly actions$ = inject(Actions);
  private readonly localeService = inject(LocaleService);
  private readonly dialogService = inject(DialogService);

  readonly dataSource = new ActiveRequestsOverviewDataSource(this.store, this.actions$);
  readonly displayColumns = [
    RequestsColumnTypes.manureCategory,
    RequestsColumnTypes.manureType,
    RequestsColumnTypes.amountInTons,
    RequestsColumnTypes.nKgPerTon,
    RequestsColumnTypes.maxNitrogen,
    RequestsColumnTypes.pKgPerTon,
    RequestsColumnTypes.maxPhosphate,
    RequestsColumnTypes.kKgPerTon,
    RequestsColumnTypes.isHomogeneous,
    RequestsColumnTypes.desiredDeliveryPeriod,
    RequestsColumnTypes.paymentType,
    RequestsColumnTypes.pricePerTon,
    RequestsColumnTypes.totalPrice,
    RequestsColumnTypes.status,
    RequestsColumnTypes.action,
  ];

  selectedCustomer$: Observable<SelectedCustomer> = this.store.pipe(
    select(UserSelectors.selectCustomer),
  );

  @ViewChild(MatTableDataSource) tableDataSource: MatTableDataSource<RequestsOverviewModel[]>;

  openMatchMakingDialog(selectedRequest: RequestsOverviewModel) {
    this.store.dispatch(MyAdvertisementsActions.openActiveRequestDialog({ selectedRequest }));
  }

  deleteRequest(request: RequestsOverviewModel) {
    this.dialogService
      .confirm({
        title: this.localeService.translate('my-dashboard.delete-confirmation-title'),
        text: this.localeService.translate('my-dashboard.delete-confirmation-message'),
        confirmButtonColor: 'primary',
        confirmButtonText: this.localeService.translate(
          'my-dashboard.delete-confirmation-confirm-text',
        ),
        cancelButtonText: this.localeService.translate(
          'my-dashboard.delete-confirmation-cancel-text',
        ),
      })
      .pipe(take(1))
      .subscribe((result) => {
        if (result.status === DIALOG_RETURN_TYPES.confirm) {
          this.store.dispatch(MyAdvertisementsActions.deleteRequest({ id: request.id }));
        }
      });
  }
}
